import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";
import { IHospitalModel } from "@/model";

/**
 *  机构读物
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class HospitalService extends ServiceBase {

    /**
     * 获取机构列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getHospitalPage(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getHospitalPage({ data });
        return response;
    }

    /**
     * 删除机构
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async delHospital(id: any): Promise<IHttpResponse> {
        let response = await this.apis.delHospital({ urlPath:{id} });
        return response;
    }

    /**
     * 获取机构
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getHospital(id: any): Promise<IHttpResponse> {
        let response = await this.apis.getHospital({ urlPath:{id} });
        return response;
    }

    /**
     * 新增/编辑机构
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async opertionHospital(data: IHospitalModel): Promise<IHttpResponse> {
        let response;

        if(data.id)
        {
            response = await this.apis.editHospital({ data: data });
        }
        else
        {
            response = await this.apis.addHospital({ data: data });
        }
        
        return response;
    }

    /**
     * 新增排期
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async addScheduling(data: any): Promise<IHttpResponse> {
        let  response = await this.apis.addScheduling({data: data});
        
        return response;
    }

    /**
     * 修改排期
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async setScheduling(data: any): Promise<IHttpResponse> {
        let  response = await this.apis.setScheduling({data: data});
        
        return response;
    }

    /**
     * 修改排期状态
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async setSchedulingStatus(data: any): Promise<IHttpResponse> {
        let  response = await this.apis.setSchedulingStatus({data: data});
        
        return response;
    }
    
    /**
     * 获取排期详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getSchedulingDetail(id: number): Promise<IHttpResponse> {
        let  response = await this.apis.getSchedulingDetail({urlPath:{id}});
        
        return response;
    }

    /**
     * 修改机构设置
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async updateOrgSeting(data: any): Promise<IHttpResponse> {
        let  response = await this.apis.updateOrgSeting({data: data});
        
        return response;
    }

    /**
     * 获取机构设置详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getOrgSetingDetail(): Promise<IHttpResponse> {
        let  response = await this.apis.getOrgSetingDetail({});
        
        return response;
    }

    /**
     * 获取机构体检设置详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getPhysicalSeting(departmentType: number): Promise<IHttpResponse> {
        let  response = await this.apis.getPhysicalSeting({
            urlPath:
            {
                departmentType
            }
        });
        
        return response;
    }
    
    /**
     * 设置体检科室信息
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async setPhysicalDateExt(data: any): Promise<IHttpResponse> {

        let  response = await this.apis.setPhysicalDateExt({
            data: data
        });
        
        return response;
    }

    /**
     * 设置体检科室信息
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async setPhysicalDateStatus(data: any): Promise<IHttpResponse> {

        let  response = await this.apis.setPhysicalDateStatus({
            data: data
        });
        
        return response;
    }

}